import { StyledRow, StyledCol } from './style';

export const Row = (props) => {
  return <StyledRow className="row">{props.children}</StyledRow>;
}

export const Col = ({ children, className }) => {
  let classes = ['col', className];

  return <StyledCol className={classes.join(' ')}>{children}</StyledCol>;
}
